import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@core/components/footer/footer.component';
import { NavbarComponent } from '@core/components/navbar/navbar.component';
import { AccessRequestPageComponent } from '@core/pages/access-request/access-request.page';
import { HomePageComponent } from '@core/pages/home/home.page';
import { ActiveGuardService } from '@core/services/active-guard.service';
import { LoadingHttpInterceptor } from '@shared/services/loading-interceptor.service';
import { SharedModule } from '@shared/shared.module';
import { CreateServiceTicketComponent } from './components/create-service-ticket/create-service-ticket.component';
import { LoaderComponent } from './components/loader/loader.component';
import { FaqListItemComponent } from './dialogs/help/faq/faq-list-item/faq-list-item.component';
import { FaqListComponent } from './dialogs/help/faq/faq-list.component';
import { HelpComponent } from './dialogs/help/help.component';
import { InactiveGuardService } from './services/inactive-guard.service';
import { AvailabilitySpaceSyncService } from './services/property/availability-space-sync.service';
import { IndeterminateDirective } from './utils/directives/indeterminate.directive';
import { ShowFavoriteColumnDirective } from './utils/directives/show-favorite-column.directive';
import { ShowFavoriteGroupSectionDirective } from './utils/directives/show-favorite-group-section.directive';
import { ShowFavoriteSectionDirective } from './utils/directives/show-favorite-section.directive';
import { FAQSearchPipe } from './utils/pipes/faq-search.pipe';
import { UsernameInitialsPipe } from './utils/pipes/username-initials.pipe';
import { FeatureTogglesModule } from '@cbre/feature-toggles';
import { DigitalAssistantButtonComponent } from '@miq/digital-assistant';

@NgModule({
  declarations: [
    HomePageComponent,
    NavbarComponent,
    FooterComponent,
    AccessRequestPageComponent,
    HelpComponent,
    CreateServiceTicketComponent,
    LoaderComponent,
    FaqListComponent,
    FaqListItemComponent,
    FAQSearchPipe,
    ShowFavoriteColumnDirective,
    ShowFavoriteSectionDirective,
    ShowFavoriteGroupSectionDirective,
    IndeterminateDirective,
    UsernameInitialsPipe,
  ],
  exports: [
    HomePageComponent,
    FooterComponent,
    IndeterminateDirective,
    LoaderComponent,
    ShowFavoriteColumnDirective,
    ShowFavoriteSectionDirective,
    ShowFavoriteGroupSectionDirective,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FeatureTogglesModule.forChild(),
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    DigitalAssistantButtonComponent,
  ],
  providers: [
    AvailabilitySpaceSyncService,
    ActiveGuardService,
    InactiveGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingHttpInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
